document.documentElement.classList.remove('no-js');

const menu = document.querySelector('[data-mobile-menu]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const menuClose = document.querySelector('[data-menu-close]');

function setMenu(open) {
  if (!menu || !menuToggle) return;
  menu.hidden = !open;
  menuToggle.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
}

menuToggle?.addEventListener('click', () => setMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
menuClose?.addEventListener('click', () => setMenu(false));
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

document.querySelectorAll('[data-slideshow]').forEach((root) => {
  const slides = [...root.querySelectorAll('[data-slide]')];
  const dots = [...root.querySelectorAll('[data-slide-dot]')];
  const counter = root.querySelector('[data-slide-counter]');
  const pause = root.querySelector('[data-slide-pause]');
  const delay = Number(root.dataset.autoplay) || 7000;
  let index = 0;
  let playing = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer;

  function show(next) {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-pressed', String(i === index)); });
    if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
  }
  function schedule() { clearInterval(timer); if (playing && !document.hidden && slides.length > 1) timer = setInterval(() => show(index + 1), delay); }

  root.querySelector('[data-slide-prev]')?.addEventListener('click', () => { show(index - 1); schedule(); });
  root.querySelector('[data-slide-next]')?.addEventListener('click', () => { show(index + 1); schedule(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); schedule(); }));
  pause?.addEventListener('click', () => { playing = !playing; pause.textContent = playing ? 'PAUSE' : 'PLAY'; schedule(); });
  root.addEventListener('mouseenter', () => clearInterval(timer));
  root.addEventListener('mouseleave', schedule);
  root.addEventListener('focusin', () => clearInterval(timer));
  root.addEventListener('focusout', schedule);
  document.addEventListener('visibilitychange', schedule);
  let touchStart;
  root.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
  root.addEventListener('touchend', event => {
    const distance = event.changedTouches[0].clientX - touchStart;
    if (Math.abs(distance) > 60) { show(index + (distance < 0 ? 1 : -1)); schedule(); }
  }, { passive: true });
  if (pause) pause.textContent = playing ? 'PAUSE' : 'PLAY';
  show(0);
  schedule();
});
